import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import UserPicker from './view/index.tsx';

export default ComponentWithAnalytics('UserPicker', {
	onChange: 'changed',
})(UserPicker);
